import dayjs from "dayjs";
import Enums from "../enums/enums";
import userInfo from "../function/userInfo";
import i18n from "../locales/i18n";
import shareHelper from "./shareHelper";

const modNumberForBtnSampleMerchant = 5;
const demoOrganizeExpireDate = 7;

function GetMerchantBranchCodeForCreateMerchant(merchantTemplate) {
  if (merchantTemplate.branchTypeId == Enums.BranchCompanyType.Quarter) {
    return "00000";
  } else {
    return merchantTemplate.branchCode.value ? merchantTemplate.branchCode.value : "00000";
  }
}

function GetSettingViewTemplateForSave(transactionType, financeType, expenseType, isRecerring, settingViewTemplate) {
  let settingViewTemplateMockup = { ...settingViewTemplate };

  switch (transactionType) {
    case Enums.TransactionType.Quotation:
      if (financeType == Enums.FinanceType.OutFlow) {
        if (expenseType == Enums.TransactionItemType.Asset) {
          settingViewTemplateMockup.showClassification = true;
          if (settingViewTemplateMockup.createDocumentType == Enums.CreateDocumentType.NewForm) {
            settingViewTemplateMockup.showAccount = true;
            settingViewTemplateMockup.showProduct = true;
          }
        }
      }
      break;
    case Enums.TransactionType.Invoice:
      if (financeType == Enums.FinanceType.InFlow) {
        if (expenseType == Enums.TransactionItemType.Asset) {
          settingViewTemplateMockup.showClassification = true;
          if (settingViewTemplateMockup.createDocumentType == Enums.CreateDocumentType.NewForm) {
            settingViewTemplateMockup.showAccount = true;
            settingViewTemplateMockup.showProduct = true;
          }
        }
      } else if (financeType == Enums.FinanceType.OutFlow) {
        if (expenseType == Enums.TransactionItemType.Service) {
          if (settingViewTemplateMockup.createDocumentType == Enums.CreateDocumentType.NewForm) {
            settingViewTemplateMockup.showAccount = true;
          }
        } else if (expenseType == Enums.TransactionItemType.Asset) {
          settingViewTemplateMockup.showClassification = true;
          if (settingViewTemplateMockup.createDocumentType == Enums.CreateDocumentType.NewForm) {
            settingViewTemplateMockup.showAccount = true;
            settingViewTemplateMockup.showProduct = true;
          }
        }
      }
      break;
    case Enums.TransactionType.Receipt:
      if (financeType == Enums.FinanceType.InFlow) {
        if (expenseType == Enums.TransactionItemType.Asset) {
          if (settingViewTemplateMockup.createDocumentType == Enums.CreateDocumentType.NewForm) {
            settingViewTemplateMockup.showAccount = true;
            settingViewTemplateMockup.showProduct = true;
          }
        }
      }
      break;
    case Enums.TransactionType.TaxInvoice:
      if (financeType == Enums.FinanceType.InFlow) {
        settingViewTemplateMockup.showClassification = true;
      }
      break;
  }

  return {
    transactionType: transactionType,
    financeType: financeType,
    expenseType: expenseType,
    isRecerring: isRecerring,
    settingViewTemplate: settingViewTemplateMockup,
  };
}

export const CheckHiddenSideBarSettingByRouterName = (routeName) => {
  const hideSidebarList = ["manageUserRole", "addNewUser"];
  return hideSidebarList.includes(routeName);
};

export default {
  IsOrdinaryPerson(contactType) {
    let isOrdinaryPerson =
      contactType === Enums.MerchantType.OrdinaryPerson ||
      contactType === Enums.MerchantType.Shop ||
      contactType === Enums.MerchantType.OrdinaryPartnership ||
      contactType === Enums.MerchantType.BodyOfPersons;
    return isOrdinaryPerson;
  },
  GetMerchantTemplateDefault(taxId = "", branchCode = "") {
    let merchantTemplate = {
      taxId: {
        value: taxId,
        validateError: false,
      },
      branchTypeId: Enums.BranchCompanyType.Quarter,
      branchCode: {
        value: branchCode,
        validateError: false,
      },
      typeOfPerson: { value: 2 }, //ประเภทบุคคล
      typeCompany: { value: Enums.MerchantType.CompanyLimited }, //นิติบุคคล
      otherTypeCompany: "", //???
      companyName: {
        //ชื่อกิจการ
        value: "",
        validateError: false,
      },
      prefixName: { value: Enums.PrefixNameType.Mr }, //คำหน้า
      prefixOtherName: {
        //คำหน้าอื่นๆ
        value: "",
        validateError: false,
      },
      firstname: {
        value: "",
        validateError: false,
      },
      lastname: {
        value: "",
        validateError: false,
      },
      merchantSizeEmployee: {
        value: 0,
      },
      merchantUsageType: {
        value: 0,
      },
      merchantTypeOfBusiness: {
        value: 0,
      },
      merchantVATRegistrationType: {
        value: false,
      },
      registeredAddressType: 0,
      registeredAddress: {
        building: {
          value: "",
          validateError: false,
        },
        homeNo: {
          value: "",
          validateError: false,
        },
        village: {
          value: "",
          validateError: false,
        },
        villageNo: {
          value: "",
          validateError: false,
        },
        floor: {
          value: "",
          validateError: false,
        },
        roomNo: {
          value: "",
          validateError: false,
        },
        soi: {
          value: "",
          validateError: false,
        },
        road: {
          value: "",
          validateError: false,
        },
        district: {
          value: "",
          validateError: false,
        },
        amphoe: {
          value: "",
          validateError: false,
        },
        province: {
          value: "",
          validateError: false,
        },
        zipcode: {
          value: "",
          validateError: false,
        },
      },
      whoAreYou: 1,
      needCallBackToGuide: false,
      needSetupService: false,
      needToFindAccountingService: false,
      needToGetFinance: false,
      baseMerchantOwnCustomerModel: {
        isOrdinaryPerson: false,
        isJuristicPerson: false,
        isGovernment: false,
        isForeignCustomer: false,
      },
      consultingForm: {
        isRequestCallback: true,
        requestCallbackPhoneNumber: "",
        requestCallbackPeriod: "",
        needConsultingServices: [],
        otherSpecific: "",
      },
    };
    return merchantTemplate;
  },
  SetCreateMerchantModel(merchantTemplate, accountingFirmId) {
    let createMerchantModel = {
      merchantName:
        merchantTemplate.typeOfPerson.value == Enums.TypeOfPerson.OrdinaryPerson &&
        merchantTemplate.typeCompany.value == Enums.MerchantType.OrdinaryPerson
          ? merchantTemplate.firstname.value + " " + merchantTemplate.lastname.value
          : merchantTemplate.companyName.value,
      // no: GetAddressMerchant(merchantTemplate),
      no: merchantTemplate.registeredAddress.homeNo.value,
      building: merchantTemplate.registeredAddressType == 0 ? merchantTemplate.registeredAddress.building.value : "",
      roomNo: merchantTemplate.registeredAddressType == 0 ? merchantTemplate.registeredAddress.roomNo.value : "",
      floorNo: merchantTemplate.registeredAddressType == 0 ? merchantTemplate.registeredAddress.floor.value : "",
      homeGroup: merchantTemplate.registeredAddressType == 1 ? merchantTemplate.registeredAddress.village.value : "",
      homeNo: merchantTemplate.registeredAddress.villageNo.value,
      isVat: merchantTemplate.merchantVATRegistrationType.value == 0 ? false : true,
      soi: merchantTemplate.registeredAddress.soi.value,
      road: merchantTemplate.registeredAddress.road.value,
      district: merchantTemplate.registeredAddress.amphoe.value,
      subDistrict: merchantTemplate.registeredAddress.district.value,
      country: "Thailand",
      province: merchantTemplate.registeredAddress.province.value,
      postcode: merchantTemplate.registeredAddress.zipcode.value,
      taxId: merchantTemplate.taxId.value,
      branch: GetMerchantBranchCodeForCreateMerchant(merchantTemplate),
      merchantTypeId: merchantTemplate.typeCompany.value,
      accountingFirmId: accountingFirmId > 0 ? accountingFirmId : null,
      businessCategoryId: merchantTemplate.merchantTypeOfBusiness.value,
      organizationSizeId: merchantTemplate.merchantSizeEmployee.value,
      createdUserPositionId: merchantTemplate.whoAreYou,
      userRequestSupportPhoneNumber: "",
      isRequestAccountingService: false,
      needCallBackToGuide: merchantTemplate.needCallBackToGuide,
      needSetupService: merchantTemplate.needSetupService,
      needToFindAccountingService: merchantTemplate.needToFindAccountingService,
      needToGetFinance: merchantTemplate.needToGetFinance,
      baseMerchantOwnCustomerModel: merchantTemplate.baseMerchantOwnCustomerModel,
      consultingForm: merchantTemplate.consultingForm,
    };
    return createMerchantModel;
  },
  SetMerchantCreateTemplateBySearchedMerchantAddress(merchantTemplate, searchedAddress) {
    merchantTemplate.taxId.value = searchedAddress.taxId;
    merchantTemplate.branchCode.value = searchedAddress.branchCode;
    merchantTemplate.typeOfPerson = shareHelper.GetTypeOfPersonBySearchedAddress(searchedAddress.merchantType);
    merchantTemplate.typeCompany = { value: searchedAddress.merchantType };
    if (
      merchantTemplate.typeOfPerson.value === Enums.TypeOfPerson.OrdinaryPerson &&
      searchedAddress.merchantType === Enums.MerchantType.OrdinaryPerson
    ) {
      let fullName = searchedAddress.name.split(/ (.*)/);
      merchantTemplate.firstname.value = fullName.length > 0 ? fullName[0] : "";
      merchantTemplate.lastname.value = fullName.length > 1 ? fullName[1] : "";
      merchantTemplate.prefixName = { value: searchedAddress.personalNamePrefixTypeId };
    } else {
      merchantTemplate.companyName.value = searchedAddress.name;
    }
    merchantTemplate.merchantVATRegistrationType = searchedAddress.isVat ? { value: true } : { value: false };

    merchantTemplate.registeredAddressType = searchedAddress.building ? 0 : 2;

    merchantTemplate.registeredAddress.building.value = searchedAddress.building;
    merchantTemplate.registeredAddress.homeNo.value = searchedAddress.no;
    merchantTemplate.registeredAddress.villageNo.value = searchedAddress.homeNo;
    merchantTemplate.registeredAddress.floor.value = searchedAddress.floorNo;
    merchantTemplate.registeredAddress.roomNo.value = searchedAddress.roomNo;
    merchantTemplate.registeredAddress.soi.value = searchedAddress.soi;
    merchantTemplate.registeredAddress.road.value = searchedAddress.road;

    merchantTemplate.registeredAddress.district.value = searchedAddress.subDistrict;
    merchantTemplate.registeredAddress.amphoe.value = searchedAddress.district;
    merchantTemplate.registeredAddress.province.value = searchedAddress.province;
    merchantTemplate.registeredAddress.zipcode.value = searchedAddress.postCode;
  },
  GetMerchantFullName(merchantType, merchantName) {
    let nameType = GetMerchantName(merchantType);
    return nameType.frontName + merchantName + nameType.backName;
  },
  CompareMerchantNameTh(a, b) {
    if (a.merchantNameTh < b.merchantNameTh) {
      return -1;
    } else if (a.merchantNameTh > b.merchantNameTh) {
      return 1;
    } else {
      return 0;
    }
  },
  CompareMerchantNameEn(a, b) {
    if (a.merchantNameEng < b.merchantNameEng) {
      return -1;
    } else if (a.merchantNameEng > b.merchantNameEng) {
      return 1;
    } else {
      return 0;
    }
  },
  SetRegisterAfpPartnerModel(registerAfpPartner) {
    const registerAfpPartnerModal = {
      id: registerAfpPartner.accountingFirm.id,
      address: registerAfpPartner.accountingFirm.address,
      afpRefCode: registerAfpPartner.accountingFirm.afpRefCode,
      logoUrl: registerAfpPartner.accountingFirm.logoUrl
        ? registerAfpPartner.accountingFirm.logoUrl
        : "/Content/Image/AccountingFirm/accounting-partner-of-peak-default-logo.png",
      name: i18n.locale == "th" ? registerAfpPartner.accountingFirm.name : registerAfpPartner.accountingFirm.nameEn,
      accountingFirmMerchantId: registerAfpPartner.accountingFirm.accountingFirmMerchantId,
    };
    return registerAfpPartnerModal;
  },
  SetOnboardingNewPeak(_onboardingNewPeak) {
    let onboardingNewPeak = null;

    if (_onboardingNewPeak) {
      onboardingNewPeak = {
        isSettingOrganization: _onboardingNewPeak.isSettingOrganization,
        isSettingLogoAndStamp: _onboardingNewPeak.isSettingLogoAndStamp,
        isAddNewUser: _onboardingNewPeak.isAddNewUser,
        isCreateBackAccount: _onboardingNewPeak.isCreateBackAccount,
        isCreateProduct: _onboardingNewPeak.isCreateProduct,
        isCreateContact: _onboardingNewPeak.isCreateContact,
        isCreateReceipt: _onboardingNewPeak.isCreateReceipt,
        isCreateInvoice: _onboardingNewPeak.isCreateInvoice,
      };
    }

    return onboardingNewPeak;
  },
  ConvertToDemoOrganizeGuide(_demoOrganizeGuide) {
    let demoOrganizeGuide = null;
    if (_demoOrganizeGuide) {
      demoOrganizeGuide = {
        merchantId: _demoOrganizeGuide.merchantId,
        isViewCreateReceipt: _demoOrganizeGuide.isViewCreateReceipt,
        isViewCreateExpense: _demoOrganizeGuide.isViewCreateExpense,
        isViewProfitLoss: _demoOrganizeGuide.isViewProfitLoss,
        createdUserId: _demoOrganizeGuide.createdUserId,
        createdDateTime: _demoOrganizeGuide.createdDateTime,
        updatedUserId: _demoOrganizeGuide.updatedUserId,
        updatedDateTime: _demoOrganizeGuide.updatedDateTime,
      };
    }
    return demoOrganizeGuide;
  },
  ConvertToSettingTaxInvoice(_settingTaxInvoice) {
    let settingTaxInvoice = null;
    if (_settingTaxInvoice) {
      settingTaxInvoice = {
        invoiceTaxInvoiceType: _settingTaxInvoice.invoiceTaxInvoiceType,
        receiptTaxInvoiceType: _settingTaxInvoice.receiptTaxInvoiceType,
        depositTaxInvoiceType: _settingTaxInvoice.depositTaxInvoiceType,
        canCreateTaxInvoiceNotVat: _settingTaxInvoice.canCreateTaxInvoiceNotVat,
        invoiceTaxDocumentType: _settingTaxInvoice.invoiceTaxDocumentType,
        receiptTaxDocumentType: _settingTaxInvoice.receiptTaxDocumentType,
        creditNoteTaxDocumentType: _settingTaxInvoice.creditNoteTaxDocumentType,
        debitNoteTaxDocumentType: _settingTaxInvoice.debitNoteTaxDocumentType,
        depositTaxDocumentType: _settingTaxInvoice.depositTaxDocumentType,
      };
    }
    return settingTaxInvoice;
  },
  ConvertToSettingQuotationPartial(_settingQuotationPartial) {
    let settingQuotationPartial = null;
    if (_settingQuotationPartial) {
      settingQuotationPartial = {
        isActive: _settingQuotationPartial.isActive,
        documentValueExceedType: _settingQuotationPartial.documentValueExceedType,
        editAmountType: _settingQuotationPartial.editAmountType,
        editPriceType: _settingQuotationPartial.editPriceType,
        editDiscountType: _settingQuotationPartial.editDiscountType,
        canAddProductItem: _settingQuotationPartial.canAddProductItem,
      };
    }
    return settingQuotationPartial;
  },
  ConvertToSettingPurchaseOrderPartial(_settingPurchaseOrderPartial) {
    let settingPurchaseOrderPartial = null;
    if (_settingPurchaseOrderPartial) {
      settingPurchaseOrderPartial = {
        isActive: _settingPurchaseOrderPartial.isActive,
        documentValueExceedType: _settingPurchaseOrderPartial.documentValueExceedType,
        editAmountType: _settingPurchaseOrderPartial.editAmountType,
        editPriceType: _settingPurchaseOrderPartial.editPriceType,
        editDiscountType: _settingPurchaseOrderPartial.editDiscountType,
        canAddProductItem: _settingPurchaseOrderPartial.canAddProductItem,
      };
    }
    return settingPurchaseOrderPartial;
  },
  ConvertToSettingDocumentReportURL(_settingDocumentReportURL) {
    let settingDocumentReportURL = null;
    if (_settingDocumentReportURL) {
      settingDocumentReportURL = {
        platformType: _settingDocumentReportURL.platformType,
        pageType: _settingDocumentReportURL.pageType,
      };
    }
    return settingDocumentReportURL;
  },
  ConvertToSettingCreateUserJournal(_settingCreateUserJournal) {
    let settingCreateUserJournal = null;
    if (_settingCreateUserJournal) {
      settingCreateUserJournal = {
        createUserJournalType: _settingCreateUserJournal.createUserJournalType,
        createJournalRefTransactionStatus: _settingCreateUserJournal.createJournalReferenceTransactionStatus,
        createJournalRefDepreciationStatus: _settingCreateUserJournal.createJournalReferenceAssetDepreciationStatus,
      };
    }
    return settingCreateUserJournal;
  },
  ConvertToSettingViewTransaction(_settingViewTransaction) {
    const settingViewTransaction = {
      transactionType: _settingViewTransaction.transactionType,
      financeType: _settingViewTransaction.financeType,
      expenseType: _settingViewTransaction.expenseType,
      isRecerring: _settingViewTransaction.isRecerring,
      settingViewTemplate: _settingViewTransaction.settingViewTemplate,
    };
    return settingViewTransaction;
  },
  ConvertToRedeemOnboardingNewPeak(_redeemOnboarding) {
    let redeemOnboarding = null;

    if (_redeemOnboarding) {
      redeemOnboarding = {
        id: _redeemOnboarding.id,
        merchantId: _redeemOnboarding.merchantId,
        promoCode: _redeemOnboarding.promoCode,
        promoCodeId: _redeemOnboarding.promoCodeId,
        userId: _redeemOnboarding.userId,
      };
    }

    return redeemOnboarding;
  },
  SetMissionOne(_onboardingNewPeak) {
    let mission = {
      name: i18n.t("Organization_Setting"),
      imgUrl: "/peakengine/Content/Image/Onboarding/Home/MerchantSetting.png",
      taskList: [
        {
          name: i18n.t("Organization_Informations_Onboard"),
          description: i18n.t("Organization_Information_Onboard_des"),
          onboardingNewPeakType: Enums.OnboardingNewPeakType.isSettingOrganization,
          value: _onboardingNewPeak.isSettingOrganization,
          isShowOption: false,
          link: `/setting/company?emi=${userInfo.MerchantId().PeakEncryption()}&onboarding=1`,
        },
        {
          name: i18n.t("Logo_and_Stamp"),
          description: i18n.t("Logo_and_Stamp_des"),
          onboardingNewPeakType: Enums.OnboardingNewPeakType.isSettingLogoAndStamp,
          value: _onboardingNewPeak.isSettingLogoAndStamp,
          isShowOption: false,
          link: `/setting/logoStamp?emi=${userInfo.MerchantId().PeakEncryption()}&onboarding=1`,
        },
        {
          name: i18n.t("Add_New_User_Onboard"),
          description: i18n.t("Add_New_User_Onboard_des"),
          onboardingNewPeakType: Enums.OnboardingNewPeakType.isAddNewUser,
          value: _onboardingNewPeak.isAddNewUser,
          isShowOption: false,
          link: `/setting/addUser?emi=${userInfo.MerchantId().PeakEncryption()}&onboarding=1`,
        },
      ],
    };
    return mission;
  },
  SetMissionTwo(_onboardingNewPeak) {
    let mission = {
      name: i18n.t("Add_Basic_Data"),
      imgUrl: "/peakengine/Content/Image/Onboarding/Home/InfoSetting.png",

      taskList: [
        {
          name: i18n.t("Add_New_Channel"),
          description: i18n.t("Add_New_Channel_des"),
          onboardingNewPeakType: Enums.OnboardingNewPeakType.isCreateBackAccount,
          value: _onboardingNewPeak.isCreateBackAccount,
          isShowOption: false,
          link: `/finance/cashBankWallet?emi=${userInfo.MerchantId().PeakEncryption()}&onboarding=1`,
        },
        {
          name: i18n.t("Add_Product_Service"),
          description: i18n.t("Add_Product_Service_des"),
          onboardingNewPeakType: Enums.OnboardingNewPeakType.isCreateProduct,
          value: _onboardingNewPeak.isCreateProduct,
          isShowOption: false,
          link: `/product/productIndex?emi=${userInfo.MerchantId().PeakEncryption()}&onboarding=1`,
        },
        {
          name: i18n.t("Add_New_Contact_Onboard"),
          description: i18n.t("Add_New_Contact_Onboard_des"),
          onboardingNewPeakType: Enums.OnboardingNewPeakType.isCreateContact,
          value: _onboardingNewPeak.isCreateContact,
          isShowOption: false,
          link: `/contact?emi=${userInfo.MerchantId().PeakEncryption()}&onboarding=1`,
        },
      ],
    };
    return mission;
  },
  SetMissionTree(_onboardingNewPeak) {
    let mission = {
      name: i18n.t("Create_a_Document"),
      imgUrl: "/peakengine/Content/Image/Onboarding/Home/CreateDoc.png",

      taskList: [
        {
          name: i18n.t("Create_Receipt_Onboard"),
          description: i18n.t("Create_Receipt_Onboard_des"),
          onboardingNewPeakType: Enums.OnboardingNewPeakType.isCreateReceipt,
          value: _onboardingNewPeak.isCreateReceipt,
          isShowOption: false,
          link: `/income/receiptCreate?emi=${userInfo.MerchantId().PeakEncryption()}&onboarding=1`,
        },
        {
          name: i18n.t("Expense_Record_Onboard"),
          description: i18n.t("Expense_Record_Onboard_des"),
          onboardingNewPeakType: Enums.OnboardingNewPeakType.isCreateInvoice,
          value: _onboardingNewPeak.isCreateInvoice,
          isShowOption: false,
          link: `/expense/invoiceCreate?emi=${userInfo.MerchantId().PeakEncryption()}&onboarding=1`,
        },
      ],
    };
    return mission;
  },
  ValidateOnlineViewPaymentChannelSetting(inputModel) {
    let isError = false;

    if (inputModel.isQrPayment) {
      if (inputModel.qrPaymentTypeId === Enums.QRPaymentType.UploadQRCodeImage) {
        if (inputModel.qrPaymentCodeInputModel.bankNumber.value.trim().length === 0) {
          inputModel.qrPaymentCodeInputModel.bankNumber.validateError = true;
        }
        isError = shareHelper.CheckInputValidateError(inputModel.qrPaymentCodeInputModel, isError);
      }
    }

    return isError;
  },
  PrepareOnlineViewPaymentChannelSettingInputModel(inputModel) {
    let qrPaymentCodeModel = null;

    if (inputModel.qrPaymentTypeId === Enums.QRPaymentType.UploadQRCodeImage && inputModel.qrPaymentCodeInputModel) {
      qrPaymentCodeModel = {
        imgUrlFileModel: inputModel.qrPaymentCodeInputModel.imgUrlFileModel,
        remark: inputModel.qrPaymentCodeInputModel.remark.value,
        bankReferenceId: inputModel.qrPaymentCodeInputModel.bankReferenceId,
        bankNumber: inputModel.qrPaymentCodeInputModel.bankNumber.value.trim(),
        bankTypeId: inputModel.qrPaymentCodeInputModel.bankTypeId,
      };
    }

    let input = {
      settingOnlineviewPaymentChannelModel: inputModel.settingOnlineviewPaymentChannelModel,
      isQrPayment: inputModel.isQrPayment,
      qrPaymentTypeId: inputModel.qrPaymentTypeId,
      qrPaymentCodeModel: qrPaymentCodeModel,
      isUpdateImage: inputModel.isUpdateImage,
    };
    return input;
  },
  CheckOnBoardingMerchantSampleIsSuccess(getOnBoardingMerchantSample) {
    if (getOnBoardingMerchantSample.isCreatedMerchantSample) {
      return true;
    }

    if (
      getOnBoardingMerchantSample.isCreatedContact &&
      getOnBoardingMerchantSample.isCreatedProduct &&
      getOnBoardingMerchantSample.isCreatedBankAccount &&
      getOnBoardingMerchantSample.isCreatedAllocation &&
      getOnBoardingMerchantSample.isCreatedQrCodePaymentSetting &&
      getOnBoardingMerchantSample.isCreatedInvoice &&
      getOnBoardingMerchantSample.isCreatedInvoiceWithReceipt &&
      getOnBoardingMerchantSample.isCreatedReceipt &&
      getOnBoardingMerchantSample.isCreatedExpense &&
      getOnBoardingMerchantSample.isCreatedExpenseLazadaSetBefore2MonthFromNow &&
      getOnBoardingMerchantSample.isCreatedExpenseLazadaSet2MonthFromNow &&
      getOnBoardingMerchantSample.isCreatedJournal &&
      getOnBoardingMerchantSample.isCreatedCustomDashBoard
    ) {
      return true;
    } else {
      return false;
    }
  },
  GetFavoriteMerchantList(getMerchantList, getFavoriteMerchantList) {
    let merchantList = [];
    let dummyOptionList = [];
    if (getMerchantList && getMerchantList.length > 0) {
      getMerchantList.forEach((element) => {
        let merchant = shareHelper.NewObject(element);
        const favoriteMerchant = getFavoriteMerchantList.find((x) => x.merchantId === merchant.merchant.merchantId);
        if (favoriteMerchant) {
          merchant.isFavorite = true;
          merchant.sortNumber = favoriteMerchant.sortNumber;
        } else {
          merchant.isFavorite = false;
          merchant.sortNumber = 0;
        }
        dummyOptionList.push(merchant);
      });
      if (dummyOptionList && dummyOptionList.length > 0) {
        dummyOptionList = dummyOptionList.sort((a, b) => {
          return b.sortNumber - a.sortNumber;
        });
        merchantList = dummyOptionList;
      }
    }
    return merchantList;
  },
  GetLogoUrlSku(skuType) {
    const blobStorage = process.env.VUE_APP_PeakFileServer.UrlCombine("peakengine/Content/Image/");
    let logoUrl = "";
    switch (skuType) {
      case Enums.SkuType.Lazada:
        logoUrl = blobStorage.UrlCombine("Ecommerce/Lazada.svg");
        break;
      case Enums.SkuType.Shopee:
        logoUrl = blobStorage.UrlCombine("Ecommerce/Shopee.svg");
        break;
      case Enums.SkuType.TikTokShop:
        logoUrl = blobStorage.UrlCombine("Ecommerce/Tiktok.svg");
        break;
      case Enums.SkuType.Zwiz:
        logoUrl = blobStorage.UrlCombine("Ecommerce/Zwiz.png");
        break;
    }
    return logoUrl;
  },
  GetSkuTemplateDefualtList() {
    const skuTemplateList = [
      {
        id: 0,
        isActive: false,
        name: "Lazada",
        skuType: Enums.SkuType.Lazada,
        logoUrl: this.GetLogoUrlSku(Enums.SkuType.Lazada),
      },
      {
        id: 0,
        isActive: false,
        name: "Shopee",
        skuType: Enums.SkuType.Shopee,
        logoUrl: this.GetLogoUrlSku(Enums.SkuType.Shopee),
      },
      {
        id: 0,
        isActive: false,
        name: "TikTok Shop",
        skuType: Enums.SkuType.TikTokShop,
        logoUrl: this.GetLogoUrlSku(Enums.SkuType.TikTokShop),
      },
      {
        id: 0,
        isActive: false,
        name: "ZWIZ",
        skuType: Enums.SkuType.Zwiz,
        logoUrl: this.GetLogoUrlSku(Enums.SkuType.Zwiz),
      },
    ];
    return skuTemplateList;
  },
  CheckDateCanShowBtnSampleMerchant() {
    let isShow = false;
    let date = new Date().getDate();
    if (date % modNumberForBtnSampleMerchant == 0) {
      isShow = true;
    }
    return isShow;
  },
  CheckDemoOrganizeExpireDate(_createDateMerchant) {
    let createDateMerchant = dayjs(_createDateMerchant);
    let toDate = dayjs();
    let diff = toDate.diff(createDateMerchant, "day");
    return diff > demoOrganizeExpireDate;
  },
  GetVerifyMerchantTemplateDefault() {
    const verifyMerchantTemplate = {
      merchantFileImageModel: [],
      pp20FileImageModel: [],
      idCardImageModel: [],
      logoImageModel: [],
      taxId: {
        value: "",
        validateError: false,
      },
      firstName: {
        value: "",
        validateError: false,
      },
      lastName: {
        value: "",
        validateError: false,
      },
      phoneNo: {
        value: "",
        validateError: false,
      },
      email: {
        value: "",
        validateError: false,
      },
      consentVerification: false,
      membershipAgreement: false,
      isConfirm: false,
      isCheckCertificatePP20: false,
    };
    return verifyMerchantTemplate;
  },
  ConvertToVerificationMerchantRequestModel(verifyMerchantTemplate, merchantLogoList) {
    let verificationMerchantRequest = {
      merchantFileImageModel: [],
      pp20FileImageModel: [],
      idCardImageModel: [],
      logoImageModel: null,
      consentVerification: verifyMerchantTemplate.consentVerification,
      membershipAgreement: verifyMerchantTemplate.membershipAgreement,
    };

    if (verifyMerchantTemplate.merchantFileImageModel && verifyMerchantTemplate.merchantFileImageModel.length > 0) {
      verifyMerchantTemplate.merchantFileImageModel.forEach((item) => {
        verificationMerchantRequest.merchantFileImageModel.push({
          fileName: item.fileName,
          rawString: item.rawString,
          fileType: item.fileType,
          fileUrl: item.fileFullUrl,
        });
      });
    }

    if (verifyMerchantTemplate.isCheckCertificatePP20) {
      if (verifyMerchantTemplate.pp20FileImageModel && verifyMerchantTemplate.pp20FileImageModel.length > 0) {
        verifyMerchantTemplate.pp20FileImageModel.forEach((item) => {
          verificationMerchantRequest.pp20FileImageModel.push({
            fileName: item.fileName,
            rawString: item.rawString,
            fileType: item.fileType,
            fileUrl: item.fileFullUrl,
          });
        });
      }
    }

    if (verifyMerchantTemplate.idCardImageModel && verifyMerchantTemplate.idCardImageModel.length > 0) {
      verifyMerchantTemplate.idCardImageModel.forEach((item) => {
        verificationMerchantRequest.idCardImageModel.push({
          fileName: item.fileName,
          rawString: item.rawString,
          fileType: item.fileType,
          fileUrl: item.fileFullUrl,
        });
      });
    }

    if (merchantLogoList && merchantLogoList.length > 0) {
      merchantLogoList.forEach((item) => {
        verificationMerchantRequest.logoImageModel = {
          fileName: item.fileName,
          rawString: item.rawString,
          fileType: item.fileType,
          fileUrl: item.urlImg,
        };
      });
    }

    return verificationMerchantRequest;
  },
  GetMerchantBusinessType(merchantType) {
    let typeName = "-";
    switch (merchantType) {
      case Enums.MerchantType.LimitedLiabilityPartnership:
        typeName = i18n.t("Limited_Partnership");
        break;
      case Enums.MerchantType.CompanyLimited:
        typeName = i18n.t("Company_Limited");
        break;
      case Enums.MerchantType.PublicCompanyLimited:
        typeName = i18n.t("Public_Company_Limited");
        break;
      case Enums.MerchantType.Shop:
        typeName = i18n.t("Shop");
        break;
      case Enums.MerchantType.OrdinaryPerson:
        typeName = i18n.t("Human");
        break;
      case Enums.MerchantType.BodyOfPersons:
        typeName = i18n.t("Body_of_Persons");
        break;
      case Enums.MerchantType.Others:
        typeName = i18n.t("Others");
        break;
      case Enums.MerchantType.OrdinaryPartnership:
        typeName = i18n.t("Ordinary_Partnership");
        break;
      case Enums.MerchantType.Foundation:
        typeName = i18n.t("Foundation");
        break;
      case Enums.MerchantType.Association:
        typeName = i18n.t("Association");
        break;
      case Enums.MerchantType.JointVenture:
        typeName = i18n.t("Joint_Venture");
        break;
    }
    return typeName;
  },
  GetSettingViewInputForAllTransactions(settingViewTemplate) {
    const transactionList = [
      {
        ...GetSettingViewTemplateForSave(
          // ใบเสนอราคา
          Enums.TransactionType.Quotation,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.Quotation,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบรับเงินมัดจำ
          Enums.TransactionType.Deposit,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.DepositReceipt,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบแจ้งหนี้
          Enums.TransactionType.Invoice,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.Invoice,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบแจ้งหนี้ขายสินทรัพย์
          Enums.TransactionType.Invoice,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.PurchaseAsset,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.InvoiceSellAsset,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบแจ้งหนี้อัตโนมัติ
          Enums.TransactionType.Invoice,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          true,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.RecurringInvoice,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบเสร็จรับเงิน
          Enums.TransactionType.Receipt,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.Receipt,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบเสร็จรับเงินขายสินทรัพย์
          Enums.TransactionType.Receipt,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.PurchaseAsset,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.ReceiptSellAsset,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบเสร็จรับเงินอัตโนมัติ
          Enums.TransactionType.Receipt,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          true,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.RecurringReceipt,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบกำกับภาษีขาย
          Enums.TransactionType.TaxInvoice,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.SalesTaxInvoice,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบลดหนี้
          Enums.TransactionType.CreditNote,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.CreditNote,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบเพิ่มหนี้
          Enums.TransactionType.DebitNote,
          Enums.FinanceType.InFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.DebitNote,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบขอซื้อ
          Enums.TransactionType.PurchaseRequisition,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.PurchaseRequisition,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบสั่งซื้อ
          Enums.TransactionType.Quotation,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.PurchaseOrder,
      },
      {
        ...GetSettingViewTemplateForSave(
          // บันทึกรับสินค้า/บริการ
          Enums.TransactionType.GoodsReceipt,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.GoodsReceipt,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบจ่ายเงินมัดจำ
          Enums.TransactionType.Deposit,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.DepositPayment,
      },
      {
        ...GetSettingViewTemplateForSave(
          // บันทึกรับเอกสารแจ้งหนี้
          Enums.TransactionType.InvoiceReceipt,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.InvoiceReceipt,
      },
      {
        ...GetSettingViewTemplateForSave(
          // บันทึกซื้อสินค้า
          Enums.TransactionType.Invoice,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.PurchaseInventory,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.PurchaseInventoryRecord,
      },
      {
        ...GetSettingViewTemplateForSave(
          // บันทึกค่าใช้จ่าย
          Enums.TransactionType.Invoice,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.Expense,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.ExpenseRecord,
      },
      {
        ...GetSettingViewTemplateForSave(
          // บันทึกค่าใช้จ่ายอัตโนมัติ
          Enums.TransactionType.Invoice,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.Expense,
          true,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.RecurringExpense,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ซื้อสินทรัพย์
          Enums.TransactionType.Invoice,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.PurchaseAsset,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.PurchaseAsset,
      },
      {
        ...GetSettingViewTemplateForSave(
          // ใบสั่งซื้อสินทรัพย์
          Enums.TransactionType.Quotation,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.PurchaseAsset,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.PurchaseOrderAsset,
      },
      {
        ...GetSettingViewTemplateForSave(
          // รับใบลดหนี้
          Enums.TransactionType.CreditNote,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.ReceiveCreditNote,
      },
      {
        ...GetSettingViewTemplateForSave(
          // รับใบเพิ่มหนี้
          Enums.TransactionType.DebitNote,
          Enums.FinanceType.OutFlow,
          Enums.ExpenseType.None,
          false,
          settingViewTemplate
        ),
        settingDocumentType: Enums.SettingViewTransactionDocumentType.ReceiveDebitNote,
      },
    ];
    return transactionList;
  },
  GetUpdateAllSettingViewTransactionLoadingProgressTemplate() {
    return [
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.Quotation,
        name: i18n.t("Quotation"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.DepositReceipt,
        name: i18n.t("Deposit_Receipt"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.Invoice,
        name: i18n.t("Invoice"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.InvoiceSellAsset,
        name: i18n.t("Sell_Asset_Invoice"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.RecurringInvoice,
        name: i18n.t("Recurring_Invoice"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.Receipt,
        name: i18n.t("Receipt"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.ReceiptSellAsset,
        name: i18n.t("Sell_Asset_Receipt"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.RecurringReceipt,
        name: i18n.t("Recurring_Receipt"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.SalesTaxInvoice,
        name: i18n.t("Menu_SalesTaxInvoice"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.CreditNote,
        name: i18n.t("Credit_Note"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.DebitNote,
        name: i18n.t("Debit_Note"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.PurchaseRequisition,
        name: i18n.t("Purchase_Requisition"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.PurchaseOrder,
        name: i18n.t("Purchase_Order"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.GoodsReceipt,
        name: i18n.t("Goods_Receipt"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.DepositPayment,
        name: i18n.t("Deposit_Payment"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.InvoiceReceipt,
        name: i18n.t("Invoice_Receipt"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.PurchaseInventoryRecord,
        name: i18n.t("Menu_PurchaseInventoryRecord"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.ExpenseRecord,
        name: i18n.t("Expense_Record"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.RecurringExpense,
        name: i18n.t("Recurring_Expense"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.PurchaseAsset,
        name: i18n.t("Menu_PurchaseAsset"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.PurchaseOrderAsset,
        name: i18n.t("Purchase_Order_Asset"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.ReceiveCreditNote,
        name: i18n.t("Receive_Credit_Note"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
      {
        settingViewTransaction: Enums.SettingViewTransactionDocumentType.ReceiveDebitNote,
        name: i18n.t("Receive_Debit_Note"),
        loadingStatus: Enums.LoadingStatusType.Loading,
      },
    ];
  },
  SetMerchantForDisplay(merchant) {
    return {
      isSample: merchant.isSample,
      merchantBranchCode: merchant.merchantBranchCode,
      merchantId: merchant.merchantId,
      merchantName: merchant.merchantName,
      merchantNameEng: merchant.merchantNameEng,
      merchantNameTh: merchant.merchantNameTh,
    };
  },
};

function GetAddressMerchant(merchantTemplate) {
  switch (merchantTemplate.registeredAddressType) {
    case 0:
      return `${merchantTemplate.registeredAddress.building.value} ${merchantTemplate.registeredAddress.homeNo.value} ${merchantTemplate.registeredAddress.villageNo.value} ${merchantTemplate.registeredAddress.floor.value} ${merchantTemplate.registeredAddress.roomNo.value}`;
      break;
    case 1:
      return `${merchantTemplate.registeredAddress.village.value} ${merchantTemplate.registeredAddress.homeNo.value} ${merchantTemplate.registeredAddress.villageNo.value}`;
      break;
    case 2:
      return `${merchantTemplate.registeredAddress.homeNo.value} ${merchantTemplate.registeredAddress.villageNo.value}`;
      break;
  }
}

function GetMerchantName(merchantType) {
  let frontName = "";
  let backName = "";
  switch (merchantType) {
    case Enums.MerchantType.LimitedLiabilityPartnership:
      frontName = i18n.locale == "th" ? "ห้างหุ้นส่วนจำกัด " : "";
      backName = i18n.locale == "th" ? "" : " Limited Partnership";
      break;
    case Enums.MerchantType.CompanyLimited:
      frontName = i18n.locale == "th" ? "บริษัท " : "";
      backName = i18n.locale == "th" ? " จำกัด" : " Company Limited";
      break;
    case Enums.MerchantType.PublicCompanyLimited:
      frontName = i18n.locale == "th" ? "บริษัท " : "";
      backName = i18n.locale == "th" ? " จำกัด (มหาชน)" : " Public Company Limited";
      break;
    case Enums.MerchantType.Shop:
      frontName = i18n.locale == "th" ? "ร้าน " : "";
      backName = i18n.locale == "th" ? "" : " Shop";
      break;
    case Enums.MerchantType.OrdinaryPerson:
      frontName = "";
      backName = "";
      break;
    case Enums.MerchantType.BodyOfPersons:
      frontName = i18n.locale == "th" ? "คณะบุคคล " : "";
      backName = i18n.locale == "th" ? "" : " Body of Persons";
      break;
    case Enums.MerchantType.Others:
      frontName = "";
      backName = "";
      break;
    case Enums.MerchantType.OrdinaryPartnership:
      frontName = i18n.locale == "th" ? "ห้างหุ้นส่วนสามัญ " : "";
      backName = i18n.locale == "th" ? "" : " Ordinary Partnership";
      break;
    case Enums.MerchantType.Foundation:
      frontName = i18n.locale == "th" ? "มูลนิธิ " : "";
      backName = i18n.locale == "th" ? "" : " Foundation";
      break;
    case Enums.MerchantType.Association:
      frontName = i18n.locale == "th" ? "สมาคม " : "";
      backName = i18n.locale == "th" ? "" : " Association";
      break;
    case Enums.MerchantType.JointVenture:
      frontName = i18n.locale == "th" ? "กิจการร่วมค้า " : "";
      backName = i18n.locale == "th" ? "" : " Joint Venture";
      break;
  }
  return { frontName, backName };
}
export const GetDefualtSettingViewTemplate = () => {
  return {
    showReferenceName: false,
    showClassification: false,
    showCurrency: false,
    showProduct: true,
    showAccount: true,
    showQuantity: true,
    showDiscount: false,
    showVAT: true,
    showPreVATAmount: true,
    showWHT: true,
    createDocumentType: Enums.CreateDocumentType.NewForm,
  };
};

export function GetSettingViewTransactionDocumentType(_transactionType, _financeType, _expenseType, _isRecurring) {
  let documentType = Enums.SettingViewTransactionDocumentType.None;

  const transactionType = _transactionType;
  const financeType = _financeType;
  const expenseType = _expenseType === undefined ? Enums.ExpenseType.None : _expenseType;
  const isRecurring = _isRecurring === undefined ? false : _isRecurring;

  switch (transactionType) {
    case Enums.TransactionType.PurchaseRequisition:
      documentType = Enums.SettingViewTransactionDocumentType.PurchaseRequisition;
      break;
    case Enums.TransactionType.Quotation:
      if (financeType === Enums.FinanceType.InFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.Quotation;
      } else if (financeType === Enums.FinanceType.OutFlow) {
        if (expenseType === Enums.ExpenseType.PurchaseAsset) {
          documentType = Enums.SettingViewTransactionDocumentType.PurchaseOrderAsset;
        } else {
          documentType = Enums.SettingViewTransactionDocumentType.PurchaseOrder;
        }
      }
      break;
    case Enums.TransactionType.Deposit:
      if (financeType === Enums.FinanceType.InFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.DepositReceipt;
      } else if (financeType === Enums.FinanceType.OutFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.DepositPayment;
      }
      break;
    case Enums.TransactionType.Invoice:
      if (financeType === Enums.FinanceType.InFlow) {
        if (expenseType === Enums.ExpenseType.PurchaseAsset) {
          documentType = Enums.SettingViewTransactionDocumentType.InvoiceSellAsset;
        } else {
          documentType = isRecurring
            ? Enums.SettingViewTransactionDocumentType.RecurringInvoice
            : Enums.SettingViewTransactionDocumentType.Invoice;
        }
      } else if (financeType === Enums.FinanceType.OutFlow) {
        if (expenseType === Enums.ExpenseType.Expense) {
          documentType = isRecurring
            ? Enums.SettingViewTransactionDocumentType.RecurringExpense
            : Enums.SettingViewTransactionDocumentType.ExpenseRecord;
        } else if (expenseType === Enums.ExpenseType.PurchaseInventory) {
          documentType = Enums.SettingViewTransactionDocumentType.PurchaseInventoryRecord;
        } else if (expenseType === Enums.ExpenseType.PurchaseAsset) {
          documentType = Enums.SettingViewTransactionDocumentType.PurchaseAsset;
        }
      }
      break;
    case Enums.TransactionType.Receipt:
      if (financeType === Enums.FinanceType.InFlow) {
        if (expenseType === Enums.ExpenseType.PurchaseAsset) {
          documentType = Enums.SettingViewTransactionDocumentType.ReceiptSellAsset;
        } else {
          documentType = isRecurring
            ? Enums.SettingViewTransactionDocumentType.RecurringReceipt
            : Enums.SettingViewTransactionDocumentType.Receipt;
        }
      }
      break;
    case Enums.TransactionType.TaxInvoice:
      if (financeType === Enums.FinanceType.InFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.SalesTaxInvoice;
      }
      break;
    case Enums.TransactionType.CreditNote:
      if (financeType === Enums.FinanceType.InFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.CreditNote;
      } else if (financeType === Enums.FinanceType.OutFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.ReceiveCreditNote;
      }
      break;
    case Enums.TransactionType.DebitNote:
      if (financeType === Enums.FinanceType.InFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.DebitNote;
      } else if (financeType === Enums.FinanceType.OutFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.ReceiveDebitNote;
      }
      break;
    case Enums.TransactionType.GoodsReceipt:
      if (financeType === Enums.FinanceType.OutFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.GoodsReceipt;
      }
      break;
    case Enums.TransactionType.InvoiceReceipt:
      if (financeType === Enums.FinanceType.OutFlow) {
        documentType = Enums.SettingViewTransactionDocumentType.InvoiceReceipt;
      }
      break;
  }

  return documentType;
}
